import { type PaginatedDeployment } from "@/api/resources/deployments/types";
import { type PaginatedDevice, type PaginatedTransformedDevice } from "@/api/resources/devices/types";
import type { FilterOptions } from "@/providers/globalFiltersConfig";
import { type ConnectionStatus } from "@/supabase.types";
import { filterNotEmpty, sortObjectsBy } from "@/utils/format";

export const transformPaginatedDevices = (_devices: PaginatedDevice[]): PaginatedTransformedDevice[] => {
  return _devices.filter(filterNotEmpty).map((device) => {
    const manufacturer_name = device.manufacturer?.name ?? "";
    const model_name = device.model?.name ?? "";
    const connection_status =
      device.connections_to_devices.length > 0 ? (device.connections_to_devices[0].status as ConnectionStatus) : null;

    return {
      ...device,
      manufacturer_name,
      model_name,
      connection_status,
    };
  });
};

interface SelectorFilteredDevicesProps {
  devices: PaginatedDevice[];
  filteredDeployments: PaginatedDeployment[];
  options: FilterOptions;
}
export const selectorFilteredDevices = ({ devices, filteredDeployments, options }: SelectorFilteredDevicesProps) => {
  const filteredDeploymentsIds = filteredDeployments.map((d) => d.id);
  let _devices = devices.filter((_device) => {
    return filteredDeploymentsIds.includes(_device.deployment_id);
  });

  if (options.deployments.length > 0) {
    const _deploymentsIds = options.deployments;
    _devices = _devices.filter(({ deployment_id }) => {
      return _deploymentsIds.includes(deployment_id);
    });
  }

  if (options.manufacturers.length > 0) {
    _devices = _devices.filter(({ manufacturer_id }) => {
      if (!manufacturer_id) return false;
      return options.manufacturers.includes(manufacturer_id);
    });
  }
  if (options.deviceModels.length > 0) {
    _devices = _devices.filter(({ model_id }) => {
      if (!model_id) return false;
      return options.deviceModels.includes(model_id);
    });
  }

  return [..._devices].sort(sortObjectsBy("name"));
};
